// extracted by mini-css-extract-plugin
export default {"applePay":"CheckoutApplePay-module__applePay___2KAWH","consent":"CheckoutApplePay-module__consent___16bhz"};